import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { BackLink } from '../BackLink/BackLink';
import { MessageContainer } from '../MessageContainer/MessageContainer';
import { LayoutType } from '../../types';
import { ViewComponent, FlowStep, FlowStepComponent, ContentHolder } from './ViewContainer.styles';
import { Wave } from '../Wave/Wave';
import { useResponsiveness } from '../../responsiveness/useResponsiveness';
import { ManageCookies } from '../ManageCookies/ManageCookies';
export const ViewContainer = ({
  showMobileView,
  layoutType,
  waveType,
  showBackLink,
  children,
  messagingChildren,
  alignCentredStepAtTheTop,
  backLinkHref,
  onBackLinkClick,
  showManageCookiesLink
}) => {
  const shouldShowBackLink = layoutType === LayoutType.FramedCentredStep && !showMobileView && showBackLink;
  const shouldShowMessaging = layoutType === LayoutType.TwoColumn && messagingChildren;
  const {
    isDesktop
  } = useResponsiveness();
  const shouldShowManageCookiesLink = !isDesktop && showManageCookiesLink;
  return /*#__PURE__*/_jsxs(ViewComponent, {
    layoutType: layoutType,
    children: [/*#__PURE__*/_jsxs(FlowStep, {
      children: [/*#__PURE__*/_jsx(FlowStepComponent, {
        alignCentredStepAtTheTop: alignCentredStepAtTheTop,
        layoutType: layoutType,
        children: /*#__PURE__*/_jsxs(ContentHolder, {
          alignCentredStepAtTheTop: alignCentredStepAtTheTop,
          layoutType: layoutType,
          id: "content-holder",
          children: [shouldShowBackLink && /*#__PURE__*/_jsx(BackLink, {
            href: backLinkHref,
            onClick: onBackLinkClick
          }), children, waveType && /*#__PURE__*/_jsx(Wave, {
            waveType: waveType
          })]
        })
      }), !shouldShowMessaging && shouldShowManageCookiesLink && /*#__PURE__*/_jsx(ManageCookies, {})]
    }), shouldShowMessaging && /*#__PURE__*/_jsxs(MessageContainer, {
      layoutType: layoutType,
      children: [messagingChildren, shouldShowManageCookiesLink && /*#__PURE__*/_jsx(ManageCookies, {})]
    })]
  });
};